export const utcDatetimeInAmPmFormat = 'YYYY-MM-DD hh:mm A';
export const dateMMddYYYYFormat = 'MM/DD/yyyy';
